import { createContext, useCallback, useContext, useEffect, useState } from 'react';

export interface RecentSymbolsContextProps {
  recentSymbols: Record<string, number[]>;
  setRecentSymbols: (value: Record<string, number[]>) => void;
}
export const RecentSymbolsContext = createContext<RecentSymbolsContextProps | undefined>(undefined);
RecentSymbolsContext.displayName = 'RecentSymbolsContext';
export const useRecentSymbols = () => {
  const recentSymbolsContext = useContext(RecentSymbolsContext);

  const recentSymbols = recentSymbolsContext?.recentSymbols;
  const setRecentSymbols = recentSymbolsContext?.setRecentSymbols;

  const [recentSymbolsList, setRecentSymbolsList] = useState<string[]>([]);

  const updateRecentSymbols = useCallback(
    (symbol: string) => {
      if (symbol != null && recentSymbols != null && setRecentSymbols != null) {
        const lastMonth = Sugar.Date.create('last month').getTime();
        const timestampOfNewSelection = Date.now();
        const nextRecentSymbols = { ...recentSymbols };

        nextRecentSymbols[symbol] = [...(nextRecentSymbols[symbol] ?? []), timestampOfNewSelection];

        for (const recentSymbol in nextRecentSymbols) {
          nextRecentSymbols[recentSymbol] = nextRecentSymbols[recentSymbol].filter(ts => ts > lastMonth);
          if (nextRecentSymbols[recentSymbol].length < 1) {
            delete nextRecentSymbols[recentSymbol];
          }
        }
        setRecentSymbols(nextRecentSymbols);
      }
    },
    [recentSymbols, setRecentSymbols]
  );

  useEffect(() => {
    if (recentSymbols) {
      setRecentSymbolsList(
        Object.keys(recentSymbols).toSorted((a, b) => recentSymbols[b].length - recentSymbols[a].length)
      );
    }
  }, [recentSymbols]);

  return {
    recentSymbolsList,
    updateRecentSymbols,
  };
};
